import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VRow,{staticClass:"d-flex justify-center"},[_c(VCol,{attrs:{"cols":"","md":"12"}},[_c('h1',{staticClass:"text-h4 font-weight-bold mb-5"},[_vm._v("Concursos Activos")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }